import { render, staticRenderFns } from "./ParetoChart.vue?vue&type=template&id=440b7b15&scoped=true"
import script from "./ParetoChart.vue?vue&type=script&lang=js"
export * from "./ParetoChart.vue?vue&type=script&lang=js"
import style0 from "./ParetoChart.vue?vue&type=style&index=0&id=440b7b15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440b7b15",
  null
  
)

export default component.exports